<div class="main-container">
    @if(!isFirstLayer()) {
        <div class="toggle-icon placeholder"></div>
    }
    <li [class.first-layer]="checkFirstLayer(node())">
        <div class="parent-container">
            @if(node().children?.length > 0) {
                <span class="toggle-icon" [class.has-children]="node().children?.length > 0" (click)="onNodeClick(node(), $event)">
                    <i class="pi" [ngClass]="node().expanded ? 'pi-minus' : 'pi-plus'"></i>
                </span>
            }
            @else if (hasExpandableNodes()){
                <!-- placeholder for alignment -->
                <span class="toggle-icon placeholder"></span>
            }
            <div class="step-item parent" [class.expanded]="node().expanded"
                [class.active]="selectedStep()?.id === node().id" (click)="onStepClick($event, node())">
                @if (showCheckbox()) {
                    <p-checkbox binary="true" [inputId]="node().id" [name]="node().id" [(ngModel)]="node().checked" (onChange)="onParentCheckboxChange($event, node())"></p-checkbox>
                }
                <i class="icon folder-icon"></i>
                <span class="step-label">{{ (node()?.label || node()?.name) | translate }}</span>
            </div>
        </div>

        @if(node().children?.length > 0) {
            <ul class="stepper-children" [class.expanded]="node().expanded">
                @for(child of node().children; track $index) {
                    <!-- check if this child has children -->
                    @if(child.children?.length > 0) {
                        <!-- recurse -->
                        <li>
                            <app-preview-node [node]="child" [selectedStep]="selectedStep" [isFirstLayer]="false" (onStepClickEvent)="onStepClick($event)"/>
                        </li>
                    }
                    @else {
                        <!-- leaf node -->
                        <li>
                            <div class="step-item child" (click)="onStepClick($event, child)" [class.active]="selectedStep()?.id === child.id">
                                @if (showCheckbox()) {
                                    <p-checkbox binary="true" [inputId]="child.id" [name]="child.id" [(ngModel)]="child.checked" (onChange)="areAllChildrenChecked(node())"></p-checkbox>
                                }
                                <span class="bullet-point">•</span>
                                <span class="step-label">{{ (child?.label || child?.name) | translate }}</span>
                            </div>
                        </li>
                    }
                }
            </ul>
        }
    </li>
</div>